<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  cols="12"
                  md="3"
                >
                  <b-form-group
                    :label="`1.${trainingSystemLabel}:`"
                    label-for="trainingSystemId"
                  >
                    <v-select
                      v-model="filter.trainingSystemId"
                      :options="trainingSystems"
                      :reduce="option => option.value"
                      :disabled="disabledSelect"
                      @input="onTrainingSystemsChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <b-form-group
                    label="2.Khóa học"
                    label-for="courseId"
                  >
                    <v-select
                      v-model="filter.courseId"
                      :options="courses"
                      :reduce="option => option.value"
                      :disabled="disabledSelect"
                      @input="onCoursesChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <b-form-group
                    label="3.Học kỳ"
                    label-for="courseSemesterId"
                  >
                    <v-select
                      v-model="filter.courseSemesterId"
                      :options="courseSemesters"
                      :reduce="option => option.value"
                      :disabled="disabledSelect"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    label="Mã lớp độc lập"
                    label-for="creditClassCode"
                  >
                    <b-form-input
                      id="creditClassCode"
                      v-model="filter.code"
                      name="creditClassCode"
                      @input="onCreditClassCodeChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="4.Khoa/Bộ môn"
                    label-for="departmentId"
                  >
                    <v-select
                      v-model="filter.departmentId"
                      :options="departments"
                      :reduce="option => option.value"
                      :disabled="disabledSelect"
                      @input="onDepartmentChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="5"
                >
                  <b-form-group
                    label="5.Học phần"
                    label-for="subjectId"
                  >
                    <v-select
                      v-model="filter.subjectId"
                      :options="dropdownSubjects"
                      :reduce="option => option.value"
                      :disabled="disabledSelect"
                      @input="onSubjectChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <b-form-group
                    label="6.Lớp độc lập"
                    label-for="creditClassId"
                  >
                    <v-select
                      v-model="creditClassId"
                      :options="creditClasses"
                      :reduce="option => option.value"
                      :disabled="disabledSelect"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <b-row>
              <b-col cols="12">
                <div class="d-flex mt-1 mb-1">
                  <div class="mr-auto">
                    <b-form-checkbox
                      v-model="filter.firstExamTime"
                      :value="1"
                      :unchecked-value="0"
                      :disabled="filter.reTest === 1"
                    >
                      Tính theo điểm thi lần 1
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="filter.reTest"
                      :value="1"
                      :unchecked-value="0"
                    >
                      Thi lại
                    </b-form-checkbox>
                  </div>
                  <b-button
                    v-show="creditClassId > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onSelect"
                  >
                    <feather-icon icon="SearchIcon" /> Xem báo cáo
                  </b-button>
                  <b-button
                    v-show="itemsTable.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    style="margin-right: 5px"
                    @click="exportExcel"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="DownloadIcon" /> Xuất excel</span>
                  </b-button>
                  <b-button
                    v-show="itemsTable.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    @click="exportPdfFile"
                  >
                    <b-img
                      :src="require('@/assets/images/icons/file-icons/pdf.png')"
                      height="auto"
                      width="12"
                      class="mr-1"
                    />
                    <span class="align-items-center">Xuất PDF</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div>
                  <b-table
                    ref="table"
                    :bordered="true"
                    :small="true"
                    :hover="true"
                    :items="itemsTable"
                    :fields="fieldsTable"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BOverlay,
  BRow,
  BTable,
  VBTooltip,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { OrganizationCode } from '@/const/code';

export default {
  name: 'CreditClassStudentPoint',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormInput,
    BImg,
    BButton,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    BFormGroup,
    BForm,
    vSelect,
    BTable,
    BFormCheckbox,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 1000,
        organizationId: getUser().orgId,
        trainingSystemId: null,
        courseId: null,
        courseSemesterId: null,
        departmentId: null,
        programmeId: null,
        subjectId: null,
        status: null,
        sort: null,
        firstExamTime: 0,
        code: null,
        reTest: 0,
      },
      creditClassId: null,
      fieldsTable: [
        { key: 'index', label: '#' },
        { key: 'student_code', label: 'Mã sinh viên' },
        { key: 'full_name', label: 'Họ và tên' },
        { key: 'birthday', label: 'Ngày sinh' },
        { key: 'average_point', label: 'Điểm ĐGHP' },
        { key: 'alphabet_point', label: 'Điểm chữ' },
        { key: 'note', label: 'Ghi chú' },
      ],
      disabledSelect: false,
    }
  },
  computed: {
    ...mapGetters({
      itemsTable: 'creditClassStudentPoint/dataLists',
      creditClasses: 'creditClassStudentPoint/creditClasses',
      dropdownSubjects: 'dropdown/subjects',
      courses: 'dropdown/courses',
      trainingSystems: 'dropdown/trainingSystems',
      courseSemesters: 'dropdown/courseSemesters',
      departments: 'dropdown/departments',
      programmes: 'dropdown/programmes',
      programmeSubjects: 'dropdown/programmeSubjects',
      generalScores: 'creditClassStudentPoint/generalScores',
    }),
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  watch: {
    async creditClassId(val) {
      if (val) {
        this.filter.code = this.creditClasses.find(e => e.value === val).label
        await this.getGeneralScoresByCreditClassId({ creditClassId: val })
        if (this.generalScores.length > 0) {
          this.fieldsTable = [
            ...[
              { key: 'index', label: '#' },
              { key: 'student_code', label: 'Mã sinh viên' },
              { key: 'full_name', label: 'Họ và tên' },
              { key: 'birthday', label: 'Ngày sinh' },
            ],
            ...this.generalScores,
          ]
          if (this.filter.reTest === 0) {
            this.fieldsTable = [
              ...this.fieldsTable,
              ...[{ key: 'first_time_score', label: 'Điểm thi L1' }],
            ]
          }
          this.fieldsTable = [
            ...this.fieldsTable,
            ...[
              { key: 'average_point', label: 'Điểm ĐGHP' },
              { key: 'alphabet_point', label: 'Điểm chữ' },
              { key: 'note', label: 'Ghi chú' },
            ],
          ]
        } else {
          this.fieldsTable = [
            { key: 'index', label: '#' },
            { key: 'student_code', label: 'Mã sinh viên' },
            { key: 'full_name', label: 'Họ và tên' },
            { key: 'birthday', label: 'Ngày sinh' },
            { key: 'average_point', label: 'Điểm ĐGHP' },
            { key: 'alphabet_point', label: 'Điểm chữ' },
            { key: 'note', label: 'Ghi chú' },
          ]
        }
      }
    },
    'filter.reTest': function (val) {
      if (val === 1) {
        this.filter.firstExamTime = 0
      }
      this.fieldsTable = [
        ...[
          { key: 'index', label: '#' },
          { key: 'student_code', label: 'Mã sinh viên' },
          { key: 'full_name', label: 'Họ và tên' },
          { key: 'birthday', label: 'Ngày sinh' },
        ],
        ...this.generalScores,
      ]
      if (val === 0) {
        this.fieldsTable = [
          ...this.fieldsTable,
          ...[{ key: 'first_time_score', label: 'Điểm thi L1' }],
        ]
      }
      this.fieldsTable = [
        ...this.fieldsTable,
        ...[
          { key: 'average_point', label: 'Điểm ĐGHP' },
          { key: 'alphabet_point', label: 'Điểm chữ' },
          { key: 'note', label: 'Ghi chú' },
        ],
      ]
    },
  },
  async created() {
    const { creditClassId, creditClassCode } = this.$route.query
    if (creditClassId) {
      this.disabledSelect = true
      this.setCreditClasses({
        data: [{ value: creditClassId, label: creditClassCode }],
      })
      this.creditClassId = creditClassId
    } else {
      this.isLoading = true
      try {
        const cUser = getUser()
        this.filter.organizationId = (cUser.orgId ? cUser.orgId : 0)
        await Promise.all([
          this.getTrainingSystems({ organizationId: this.filter.organizationId }),
          this.getDepartments({ organizationId: this.filter.organizationId }),
        ])
        if (this.trainingSystems.length > 0) {
          this.filter.trainingSystemId = this.trainingSystems[0].value
          await this.getCourses(this.filter)
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    }
  },
  methods: {
    ...mapMutations({
      setTrainingSystems: 'dropdown/SET_TRAINING_SYSTEMS',
      setCreditClasses: 'creditClassStudentPoint/SET_CREDIT_CLASSES',
      setSubjects: 'dropdown/SET_SUBJECTS',
      setCourseSemester: 'dropdown/SET_COURSE_SEMESTERS',
      setCourse: 'dropdown/SET_COURSES',
    }),
    ...mapActions({
      getData: 'creditClassStudentPoint/getData',
      getTrainingSystems: 'dropdown/getTrainingSystems',
      getCourses: 'dropdown/getCourses',
      getCourseSemesters: 'dropdown/getCourseSemesters',
      getDepartments: 'dropdown/getDepartments',
      getMajors: 'dropdown/getMajors',
      getProgrammes: 'dropdown/getProgrammes',
      getProgrammeSubjects: 'dropdown/getProgrammeSubjects',
      getCreditClasses: 'creditClassStudentPoint/getCreditClasses',
      getDropdownSubjects: 'dropdown/getSubjects',
      exportPdf: 'creditClassStudentPoint/exportPdf',
      getGeneralScoresByCreditClassId: 'creditClassStudentPoint/getGeneralScoresByCreditClassId',
    }),
    showToast(title, variant = 'danger', icon = 'XCircleIcon') {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      })
    },
    async onTrainingSystemsChange(event) {
      this.isLoading = true
      try {
        this.filter.trainingSystemId = event
        this.filter.courseId = null
        this.filter.courseSemesterId = null
        if (event) {
          await this.getCourses(this.filter)
        } else {
          this.setCourse([])
          this.setCourseSemester([])
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
    async onCoursesChange(event) {
      this.isLoading = true
      try {
        this.filter.courseId = event
        this.filter.courseSemesterId = null
        if (event) {
          await this.getCourseSemesters({ organizationId: getUser().orgId, courseId: this.filter.courseId, status: null })
        } else {
          this.setCourseSemester([])
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
    async onDepartmentChange(event) {
      this.isLoading = true
      try {
        if (event) {
          this.filter.departmentId = event
          await this.getDropdownSubjects({ departmentId: event, organizationId: getUser().orgId })
          this.filter.subjectId = null
        } else {
          this.setSubjects([])
          this.setCreditClasses([])
          this.filter.subjectId = null
          this.filter.code = ''
          this.creditClassId = null
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
    async onCreditClassCodeChange(event) {
      this.isLoading = true
      try {
        if (event) {
          this.filter.code = event
          await this.getCreditClasses(this.filter)
          if (this.creditClasses.length > 0) {
            const found = this.creditClasses.find(item => item.label === this.filter.code)
            if (found) {
              this.creditClassId = found.value
            } else {
              this.creditClassId = null
              this.itemsTable = []
            }
          } else {
            this.creditClassId = null
            this.itemsTable = []
          }
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
    async onSubjectChange(event) {
      this.isLoading = true
      try {
        this.filter.subjectId = event
        this.filter.code = ''
        if (event) {
          await this.getCreditClasses(this.filter)
          if (this.creditClasses.length > 0) {
            this.creditClassId = this.creditClasses[0].value
          } else {
            this.creditClassId = null
          }
        } else {
          this.setCreditClasses([])
          this.creditClassId = null
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
    async onSelect() {
      this.isLoading = true
      try {
        if (!this.filter.courseId || !this.filter.code || !this.creditClassId) {
          this.showToast('Thông tin khóa học, mã lớp độc lập, lớp độc lập không được để trống!')
        } else {
          await this.getData({
            credit_class_id: this.creditClassId,
            firstExamTime: this.filter.firstExamTime,
            reTest: this.filter.reTest,
          })
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportExcel() {
      this.isLoading = true
      if (this.itemsTable.length > 0) {
        const headerScores = this.generalScores.map(item => item.label)
        const keyScores = this.generalScores.map(item => item.key)
        try {
          let tHeader = [
            ...['Mã sinh viên', 'Họ và tên', 'Ngày sinh'],
            ...headerScores,
          ]
          if (this.filter.reTest === 0) {
            tHeader = [
              ...tHeader,
              ...['Điểm thi L1'],
            ]
          }
          tHeader = [
            ...tHeader,
            ...['Điểm ĐGHP', 'Điểm chữ', 'Ghi chú'],
          ]
          let filterVal = [
            ...['student_code', 'full_name', 'birthday'],
            ...keyScores,
          ]
          if (this.filter.reTest === 0) {
            filterVal = [
              ...filterVal,
              ...['first_time_score'],
            ]
          }
          filterVal = [
            ...filterVal,
            ...['average_point', 'alphabet_point', 'note'],
          ]
          const dataJson = this.formatJson(filterVal, this.itemsTable)
          import('@/utils/Export2Excel').then(excel => {
            excel.export_json_to_excel({
              header: tHeader,
              data: dataJson,
              filename: 'Bảng_điểm_tổng_hợp_đánh_giá_học_phần',
              autoWidth: true,
              bookType: 'xlsx',
            })
          })
        } catch (error) {
          this.showToast(error)
        } finally {
          this.isLoading = false
        }
      } else {
        this.showToast('Chưa thực hiện lấy danh sách phách')
        this.isLoading = false
      }
    },
    async exportPdfFile() {
      if (this.itemsTable.length === 0) {
        this.showToast('Không có dữ liệu để xuất file!', 'warning', 'InfoIcon')
        return
      }
      this.isLoading = true
      try {
        const data = await this.exportPdf({
          creditClassId: this.creditClassId,
          firstExamTime: this.filter.firstExamTime,
          creditClassCode: this.filter.code,
          reTest: this.filter.reTest,
        })
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          window.open(url, '_blank')
        } else {
          this.showToast('File không có dữ liệu')
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
